import React, { useReducer, useState } from "react";
import { withRouter } from "react-router";
import logo from "../assets/logo.png";
import { checkUserTenant, loginUser } from "../services/api";

import { ToastContainer } from "react-toastify";
import SelectMenu from "../components/SelectMenu";
import useToken from "../useToken";
import useLocalStorage from "../useLocalStorage";

const formReducer = (state, event) => {
  return {
    ...state,
    [event.name]: event.value,
  };
};

const Login = (props) => {
  const { token, setToken, clearToken } = useToken();
  const { setLs } = useLocalStorage();
  const [formData, setFormData] = useReducer(formReducer, {});
  const [submitting, setSubmitting] = useState(true);
  const [tenantDefault, setTenantDefault] = useState();
  const [tenantList, setTenantList] = useState([]);

  React.useEffect(() => {
    let isMounted = true;
    if (token) {
      if (isMounted) {
        clearToken();
      }
    }
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();

    setSubmitting(true);

    const user = await loginUser(formData, tenantDefault);
    if (user) {
      setLs(user);
      setToken(user.AccessToken);

      props.history.push({
        pathname: "/",
        //state: { userResponse: user },
      });
    }

    setSubmitting(false);
  };

  const handleChange = (event) => {
    setFormData({
      name: event.target.name,
      value: event.target.value,
    });
  };

  const handleBlur = async (event) => {
    if (formData.username) {
      setSubmitting(true);
      const tenant = await checkUserTenant(formData);
      if (tenant && tenant.length > 0) {
        setTenantList(tenant);
        let defaultTenant = tenant.filter((i) => i.IsDefault);
        setTenantDefault(defaultTenant[0]);
        setSubmitting(false);
      }
    }
  };

  return (
    <>
      <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8">
          <div>
            <img className="mx-auto w-auto" src={logo} alt="logo"></img>
            <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Sign in to your account</h2>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="rounded-md shadow-sm -space-y-px">
              <fieldset>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    <p>Username</p>
                  </label>
                  <input
                    name="username"
                    className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    autoFocus={true}
                    value={formData.username || ""}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    <p>Password</p>
                  </label>
                  <input
                    type="password"
                    name="password"
                    className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
                    onChange={handleChange}
                    value={formData.password || ""}
                  />
                </div>
                <div>
                  <SelectMenu
                    title={"Business Unit"}
                    list={tenantList}
                    selectDefault={tenantDefault}
                    setSelectDefault={setTenantDefault}
                    keyName={"Tenant"}
                  />
                </div>
              </fieldset>
            </div>
            <div className="mt-6">
              <button type="submit" disabled={submitting} className="signinBtn">
                Sign in
              </button>
            </div>
          </form>
        </div>
        <ToastContainer />
      </div>
    </>
  );
};

export default withRouter(Login);
